/**
 * The light/dark switch in the header.
 */
import { useTheme } from '../../theme/ThemeContext.js';
import { IconButton } from '../../ui/finixt.js';
import { Tooltip } from '../../ui/Tooltip.js';

export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const dark = theme === 'dark';
  const label = dark ? 'Switch to light theme' : 'Switch to dark theme';
  return (
    <Tooltip label={label} side="bottom">
      <IconButton
        icon={dark ? 'dark_mode' : 'light_mode'}
        size={30}
        tone="outline"
        onClick={toggleTheme}
        aria-label={label}
      />
    </Tooltip>
  );
}
